import {ApiClientCommunication} from 'neo-common';
import {GameModuleStatus} from '../Types/GameModuleStatus';
import {ILimit} from '../Types/ILimit';

/**
 * @class GameModuleResponse - abstract class for custom game module response
 * which is in property "modules" in "ResponseBase" class.
 */
export abstract class GameModuleResponse extends ApiClientCommunication.ResponseBase {
    /**
     * @property customData - Custom data.
     * Optional.
     */
    customData: any;

    /**
     * @property status - status of module
     */
    status: GameModuleStatus;

    /**
     * @property autoStart - flag of auto start
     */
    autoStart: boolean;

    /**
     * @property limits - Game limits that were exceeded
     */
    limits: Array<ILimit>;

    /**
     * @method moduleName - name of module, like "base", "gamble", etc...
     */
    abstract moduleName(): string;
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/GameModuleResponse.ts
 **/